import { Box, Card, Container, Link, Stack, Typography } from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import LoginBackGround from "src/assets/logo/LoginBackground.png";
import AddAccountBackButton from "src/layouts/dashboard/navbar/AddAccountBackButton";
import Page from "../../components/Page";
import useLocales from "../../hooks/useLocales";
import useResponsive from "../../hooks/useResponsive";
import { PATH_AUTH } from "../../routes/paths";
import { LoginForm } from "../../sections/auth/login";

// ----------------------------------------------------------------------

export const RootStyle = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  display: "flex",
  padding: "0 100px",
  gap: "40px",
  minHeight: "100vh",
}));

export const SectionStyle = styled(Box)(({ theme }) => ({
  width: "50%",
  display: "flex",
  alignItems: "center",
  backgroundImage: `url(${LoginBackGround})`,
  backgroundRepeat: "no-repeat",
  backgroundSize: "contain",
  backgroundPosition: "left",
}));

const ContentStyle = styled(Card)(({ theme }) => ({
  gap: "18px",
  minWidth: 480,
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  padding: theme.spacing(5.5, 6),
  borderRadius: "16px",
  backgroundColor: "#FFFFFF",
  border: `1px solid #E5E7EB`,
  boxShadow: "0px 4px 24px 0px rgba(0, 0, 0, 0.10)",
}));

export default function Login() {
  const { translate, currentLang } = useLocales();
  const smUp = useResponsive("up", "sm");
  const theme = useTheme();
  const mdUp = useResponsive("up", "md");
  const [isSelfRegistrationDisabled, setIsSelfRegistrationDisabled] =
    useState(false);
  return (
    <Page title="Login">
      <RootStyle>
        {mdUp && (
          <SectionStyle>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                maxWidth: "580px",
              }}
            >
              <Typography
                variant="h4"
                fontWeight={800}
                sx={{
                  color: theme.palette.text.secondary,
                  lineHeight: 1.2,
                  fontSize: { md: 36, lg: 36 },
                }}
              >
                {translate(`login_tag_line`)}
              </Typography>

              {!isSelfRegistrationDisabled && (
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: "16px",
                    mb: 1,
                    color: theme.palette.text.secondary,
                  }}
                >
                  {translate("authentication_screen.signin_header_text")}
                  <Link
                    variant="subtitle2"
                    component={RouterLink}
                    to={PATH_AUTH.newRegister}
                    sx={{
                      color: theme.palette.primary.main,
                      fontWeight: "bold",
                    }}
                  >
                    {translate("authentication_screen.get_started")}
                  </Link>
                </Typography>
              )}
              <Typography
                variant="body1"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                }}
              >
                {translate("authentication_screen.demo_header_text")}
                <Link
                  variant="subtitle2"
                  target="_self"
                  href={`https://www.dost.io${
                    currentLang.value === "es" ? "/es/" : "/"
                  }demo`}
                  sx={{
                    color: theme.palette.secondary.dark,
                    fontWeight: "600",
                    textDecoration: "none",
                  }}
                >
                  {translate("authentication_screen.book_your_demo_now")}
                </Link>
              </Typography>
            </Box>
          </SectionStyle>
        )}

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: { xs: "100%", md: "50%" },
          }}
        >
          <ContentStyle>
            <AddAccountBackButton />
            <Stack direction="column">
              <Typography variant="h4" sx={{ fontWeight: 700 }}>
                {translate("authentication_screen.signin_title")}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: theme.palette.text.body,
                  fontWeight: 500,
                }}
              >
                {translate("authentication_screen.signin_text")}
              </Typography>
            </Stack>

            <LoginForm
              setIsSelfRegistrationDisabled={setIsSelfRegistrationDisabled}
            />

            {!smUp && !isSelfRegistrationDisabled && (
              <Typography
                variant="body2"
                align="center"
                sx={{ mt: 3, color: theme.palette.text.secondary }}
              >
                {translate("authentication_screen.signin_header_text")} {""}
                <Link
                  variant="subtitle2"
                  component={RouterLink}
                  to={PATH_AUTH.newRegister}
                  sx={{
                    color: theme.palette.primary.main,
                    fontWeight: "bold",
                  }}
                >
                  {translate("authentication_screen.get_started")}
                </Link>
              </Typography>
            )}
          </ContentStyle>
        </Box>
      </RootStyle>
    </Page>
  );
}
